export class AccessTokenStore {
    constructor() {
        this.walletAddress = null;
        this.expiryTimestamp = null;
        this._accessToken = null;
    }
    static getInstance() {
        if (!AccessTokenStore.instance) {
            AccessTokenStore.instance = new AccessTokenStore();
        }
        return AccessTokenStore.instance;
    }
    isAuthenticated(walletAddress) {
        if (this.expiryTimestamp &&
            this.expiryTimestamp > Date.now() / 1000 &&
            this.walletAddress === walletAddress.toLowerCase()) {
            return true;
        }
        return false;
    }
    get accessToken() {
        return this._accessToken;
    }
    set accessToken(token) {
        const tokenParts = token.split('.');
        if (tokenParts.length !== 3)
            throw new Error('cannot set invalid access token in store');
        const payload = JSON.parse(atob(tokenParts[1]));
        const address = payload.address;
        const exp = payload.exp;
        if (!address || !exp)
            throw new Error('address or expiry missing in access token');
        // server already sends lowercase but just to make sure in case of updates
        this.walletAddress = address.toLowerCase();
        this.expiryTimestamp = exp;
        this._accessToken = token;
    }
}
AccessTokenStore.instance = null;
